const TableCellValue = (props: any) => {
  let label = props.label ?? "";
  let disabledIcon = props.disabledIcon ?? false;
  return (
    <td onClick={props.handleClick}>
      <span className={`iconPharma material-symbols-outlined ${((disabledIcon) ? "d-none" : "")}`}>
        local_pharmacy
      </span><span className="titlePharma">{label}</span>
    </td>
  )
}

export default TableCellValue